import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function Eyebrow({ children }) {
  return (
    <span
      className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.14em] px-3 py-1.5 rounded-full"
      style={{
        color: "var(--primary-color)",
        backgroundColor: "var(--primary-50)",
        border: "1px solid color-mix(in srgb, var(--primary-color) 14%, transparent)",
      }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: "var(--primary-color)" }} />
      {children}
    </span>
  );
}

export default function ThankYou() {
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-18251804270/bf15CNPv3MEcEO7ckf9D",
        value: 1.0,
        currency: "USD",
      });
    }
  }, []);

  return (
    <main style={{ backgroundColor: "var(--bg-color)", color: "var(--text-color)" }}>
      <section className="pt-24 pb-20 sm:pt-28 sm:pb-24" style={{ background: "var(--gradient-soft)" }}>
        <div className="max-w-5xl mx-auto px-5 lg:px-8 text-center">
          <div className="flex justify-center mb-5">
            <Eyebrow>Demo booked</Eyebrow>
          </div>

          <h1 className="text-4xl sm:text-6xl font-semibold tracking-tight" style={{ color: "var(--text-color)" }}>
            Thank you for booking a{" "}
            <span className="ce-serif italic" style={{ color: "var(--accent-color)" }}>
              CoursEngage demo!
            </span>
          </h1>

          <p className="mt-6 text-lg max-w-3xl mx-auto leading-relaxed" style={{ color: "var(--muted-color)" }}>
            We are excited to show you how CoursEngage can help make classrooms more interactive with live polling,
            Q&amp;A, participation tracking, and AI-powered feedback insights.
          </p>
        </div>
      </section>

      <section className="pb-24 -mt-12">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <div
            className="rounded-2xl p-8 sm:p-10 text-center"
            style={{
              backgroundColor: "var(--card-bg)",
              border: "1px solid var(--border-color)",
              boxShadow: "var(--shadow-lg)",
            }}
          >
            <div
              className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full"
              style={{ backgroundColor: "var(--primary-50)", color: "var(--primary-color)" }}
            >
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>

            <h2 className="text-2xl sm:text-3xl font-semibold" style={{ color: "var(--text-color)" }}>
              Your demo has been scheduled.
            </h2>
            <p className="mt-4 text-base sm:text-lg" style={{ color: "var(--muted-color)" }}>
              Please check your email for the calendar invite.
            </p>
            <p className="mt-2 text-base sm:text-lg" style={{ color: "var(--muted-color)" }}>
              We look forward to speaking with you.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link to="/" className="ce-btn ce-btn-secondary w-full sm:w-auto">
                Back to Home
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M13 5l7 7-7 7" />
                </svg>
              </Link>
              <a href="https://coursengage.com" className="ce-btn ce-btn-primary w-full sm:w-auto">
                Visit CoursEngage
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M13 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
